import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
// import Pagination from "react-js-pagination";
import { useNavigate, Link } from 'react-router-dom';
import formatDateTimeToPST from '../PSTDateConvert';
import Pagination from 'react-js-pagination';
import {apiUrl} from "../../components/config";
import DatePicker from 'react-datepicker';


const ReconcileActiveNumbers = () => {
    const [name, setName] = useState('');
    const [timeZone, setTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [cid, setCid] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [reconcileHistory, setReconcileHistory] = useState([])
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [companyList, setcompanyList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [searchDate, setSearchDate] = useState("");
    const [searchEndDate, setSearchEndDate] = useState("");
    const [displayDate, setDisplayDate] = useState("");
    const [displayEndDate, setDisplayEndDate] = useState("");

    const navigate = useNavigate();
    
    useEffect(() => {
        refreshToken();
        getUserAccess();
    }, []);

    useEffect(() => {
        if(token){
         getCustomerNameList();
        } 
    }, [token]);

    useEffect(() => {
        if (access.length > 0 && token) {
            checkAccess(access, token);
        }
    }, [access, token]);

    useEffect(() => {
        getReconcileActiveNumbersHistory();
    }, [page]);


    const getCustomerNameList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data.filter(item => item.id !== 1);
            setcompanyList(allArray);
            
        } catch (error) {
           console.log(error);
            
        }
    };

    const handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
    }

    const getReconcileActiveNumbersHistory = async () => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/reconcile-active-number-history?page=${page}&limit=${20}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        setPopupOpen(false);
        setReconcileHistory(response.data.data)
        setTotalItem(response.data.totalItem)
    }    

    // Download directly from database using docstream (no S3 dependency)
    const getExportResultFromDB = async (reconcileId, filename) => {
        setPopupOpen(true);
        try {
            const response = await axiosJWT.get(
                `${baseUrl}/reconcile-active-number-export-docstream/${reconcileId}?format=xlsx`,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `reconcile_${filename || reconcileId}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download export file');
        } finally {
            setPopupOpen(false);
        }
    };

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);

            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setTimeZone(decoded.timezone)

        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);

        }
    }


    const checkAccess = async (access) => {
        if (role > 2) {
            navigate('/dashboard');
        }
    }

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    
    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleSearchDate = (date) => {
        console.log(date);
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');


        setSearchDate(formattedDate);
        setDisplayDate(date);
    };

    const handleSearchEndDate = (date) => {
        console.log(date);
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');


        setSearchEndDate(formattedDate);
        setDisplayEndDate(date);
    };

    const clearFilter = () => {
        setSearchDate("");
        setSearchEndDate("");
        setDisplayDate("");
        setDisplayEndDate("");
        setSearchValue('');
        setSelectedValue("");
    }

    const handleResumeSubmit = async() => {
        try{
            console.log(selectedValue, "selectedValue");
            console.log(searchValue, "searchValue");
            console.log(searchDate, "searchDate");
            console.log(searchEndDate, "searchEndDate");
            setPopupOpen(true);
            setButtonDisabled(true);
            const response = await axiosJWT.post(`${baseUrl}/check-reconcile-active-number-process`, {company_id:selectedValue, order_id: searchValue, searchDate:searchDate, searchEndDate:searchEndDate, token: token, url: apiUrl},{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            alert(response.data.message);
            setPopupOpen(false);

            window.location.reload();
            setButtonDisabled(false);
        }catch (error) {
            setButtonDisabled(false);
           console.log(error);
        }
    };

    const handleResumeReconcile = async(id) => {
        try{
            setPopupOpen(true);
            setButtonDisabled(true);
            const response = await axiosJWT.post(`${baseUrl}/reconcile-job-resume/${id}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            alert(response.data.message || 'Resume process started');
            setPopupOpen(false);
            window.location.reload();
            setButtonDisabled(false);
        }catch (error) {
            setButtonDisabled(false);
            setPopupOpen(false);
            console.log(error);
            alert(error.response?.data?.message || 'Failed to resume reconcile process');
        }
    };

    const formatSearchDateRange = (importItem, timeZone, role) => {
        const startDate = importItem.search_date ? formatDateTimeToPST(importItem.search_date, timeZone, role).split(' ')[0] : null;
        const endDate = importItem.search_end_date ? formatDateTimeToPST(importItem.search_end_date, timeZone, role).split(' ')[0] : null;

        if (startDate && endDate) {
            if (startDate === endDate) {
                return startDate;
            }
            return `${startDate} - ${endDate}`;
        }
        return startDate || endDate || '';
    };

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader />
                )}
                <div className="content-page">

                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Reconcile Active Numbers History</h1>
                            </div>
                        </div>                        
                        <div className="col-4 top-right-buttons">
                            <div className="export-btn addnew-button">
                                <Link to="/number-management"><span>&larr;</span> Back</Link>
                            </div>
                            
                        </div>

                    </div>
                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className='col-8'>
                                <div className='boxinput'>
                                    <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search Order Id" value={searchValue} onChange={handleSearchChange} />
                                    <select className="form-control" name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                                        <option value="">Select Company</option>
                                        {companyList.map((comp) => (
                                            <option key={comp.id} value={comp.id}>
                                                {comp.cname}
                                            </option>
                                        ))}
                                    </select>
                                    <DatePicker
                                        selected={displayDate}
                                        onChange={handleSearchDate}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="From Date"
                                        className="from-date"
                                    />
                                    <DatePicker
                                        selected={displayEndDate}
                                        onChange={handleSearchEndDate}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="To Date"
                                        className="end-date"
                                    />
                                    <button className={buttonDisabled ? 'search-btn disabled-link' : 'search-btn'} style={{marginLeft:'10px'}} onClick={handleResumeSubmit}>Reconcile</button>
                                    { (selectedValue || searchValue || searchDate  || searchEndDate) && (<a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className=" setting-section haft-whitebox">
                                <div className="search-result-section">
                                    <h3></h3>
                                </div>
                                <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>
                                            <th>Created Date ({timeZone})</th>
                                            <th>Search Date ({timeZone})</th>
                                            <th>Order Id</th>
                                            <th>Company</th>
                                            <th>Name</th>
                                            <th>Result</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reconcileHistory.map((importItem, index) => (
                                            <tr key={index}>
                                                <td>{formatDateTimeToPST(importItem.created_at, timeZone, role)}</td>
                                                <td>{formatSearchDateRange(importItem, timeZone, role)}</td>
                                                <td>{importItem.order_id}</td>
                                                <td>{importItem.cname}</td>
                                                <td>{importItem.full_name}</td>
                                                <td>
                                                    {importItem.status == 2 ? (
                                                        <button onClick={() => { getExportResultFromDB(importItem.id, importItem.path)}}>
                                                            <img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />
                                                        </button>
                                                    ) : importItem.status == 1 ? (
                                                        <span>In-Progress</span>
                                                    ) : importItem.status == 3 ? (
                                                        <>
                                                            <button onClick={() => { handleResumeReconcile(importItem.id)}} title="Resume process" style={{marginLeft: '5px'}}>
                                                                Resume
                                                            </button>
                                                        </>
                                                    ) : "Pending"}
                                                </td>
                                            </tr>))}
                                    </tbody>
                                </table>

                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default ReconcileActiveNumbers